export const negativeFeedback =
  'Ops! Houve algum erro, tente novamente mais tarde.';

export const basicSuccessFeedback = 'Sucesso!';
